import { Observer } from "mobx-react";
import { useApp } from "stores/app/context";

import translationStore from "stores/translation-store";

export default function UploadReport()
{
  const { legacyUpload: upload } = useApp();
  const errors = upload.getData("errors");

  return (
    <Observer>
    {
      () => (
        <div className="error-report">
          {
              Object.entries(errors).map(([errorType, filenames]) =>
              {
                if(filenames.length > 0)
                {
                  return (
                    <div key={errorType} className="error-report-error">
                      <div className="error-title">{translationStore.translate(`myalbums.add.complete.errors.error-${errorType.toLowerCase()}`)}</div>
                      {
                        filenames.map(filename => <div key={filename} className="error-file">{filename}</div>)
                      }
                    </div>
                  );
                }

                return null;
              })
            }
          <style jsx>
          {`
            .error-report {
              display: flex;
              flex: 1;
              flex-direction: column;
              width: 100%;
              max-height: 18rem;
              margin-top: 2rem;
              padding: 1.5rem;
              overflow-y: auto;
              overflow-x: hidden;
              font-weight: 300;
              border: 1px solid rgba(var(--inputBorder), 1);
              box-sizing: border-box;
            }

            .error-report .error-report-error+.error-report-error {
              margin-top: 2.5rem;
            }

            .error-report .error-title {
              font-size: 2rem;
            }

            .error-report .error-file {
              font-size: 1.5rem;
            }
          `}
          </style>
        </div>
      )
    }
    </Observer>
  );
}